import { createContext } from 'react';
import { SubjectLinePreheaderContextProps } from './SubjectLinePreheaderContext.props';

export const SubjectLinePreheaderContext = createContext<SubjectLinePreheaderContextProps>({
  isFormEdited: false,
  targetInputFieldId: '',
  updateSignalList: false,
  onSignalInsert: () => {},
  onSignalDelete: () => {},
  onSignalUpdate: () => {},
  setIsFormEdited: () => {},
  setUpdateSignalList: () => {},
});
